import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { getUserAuth } from "../../../recoil/selectors";
import { TrackAnalyticsEvent } from "../../../services/Analytics";

export enum ModalStep {
  Insurance = "insurance",
  IntermediateSuccess = "intermediateSuccess",
  Address = "address",
  FinalSuccess = "finalSuccess",
}

export const useModalAnalytics = (
  isOpen: boolean,
  currentStep: ModalStep,
  missingInsurance: boolean,
) => {
  const authInfo = useRecoilValue(getUserAuth);

  const trackInsuranceImpression = () => {
    if (authInfo) {
      TrackAnalyticsEvent("impression", authInfo.access_token, undefined, {
        impression_type: "Modal",
        modal_name: "Insurance Upload",
        page_name: "/client/dashboard",
      });
    }
  };

  const trackAddressImpression = () => {
    if (authInfo) {
      TrackAnalyticsEvent("impression", authInfo.access_token, undefined, {
        impression_type: "Modal",
        modal_name: missingInsurance
          ? "Billing Address Update"
          : "Address Only Upload",
        page_name: "/client/dashboard",
      });
    }
  };

  const trackInteraction = (elementName: string, buttonText: string) => {
    if (authInfo) {
      TrackAnalyticsEvent("interaction", authInfo.access_token, undefined, {
        interaction_type: "button_click",
        button_text: buttonText,
        position: "modal",
        element_name: elementName,
      });
    }
  };

  useEffect(() => {
    if (isOpen && currentStep === ModalStep.Insurance) {
      trackInsuranceImpression();
    }
  }, [isOpen, currentStep]);

  useEffect(() => {
    if (isOpen && currentStep === ModalStep.Address) {
      trackAddressImpression();
    }
  }, [isOpen, currentStep]);

  return { trackInteraction };
};
